import React, {useState} from 'react';
import PropTypes from 'prop-types';
import useAfterUpdateEffect from "utils/useAfterUpdateEffect";
import AppSelect from "componentsReusable/AppSelect";
import useDidMountEffect from "utils/useDidMountEffect";

const AmountSelect = props => {
  const [value, setValue] = useState(props.value)

  useDidMountEffect(() => {
    if(props.part.Amounts.length === 1){
      setValue(props.part.Amounts[0].QualColId)
    }
  })

  useAfterUpdateEffect(() => {
    if(props.value !== value){
      setValue(props.value)
    }
  }, [props.value])

  useAfterUpdateEffect(() => {
    if(props.part.Amounts.length === 1){
      setValue(props.part.Amounts[0].QualColId)
    }
  }, [props.part])

  useAfterUpdateEffect(() => {
    props.onChange(value)
  }, [value])

  const options = props?.part?.Amounts?.map(amount => ({
    ...amount,
    id: amount.QualColId,
  }))

  return <AppSelect
    isClearable={false}
    isSearchable={false}
    options={options}
    getLabelFn={amount => <span><span>{amount.Amount} {amount.Quantity}</span>{amount.QualColText && <span className="text-secondary ml-2">({amount.QualColText})</span>}</span>}
    onChange={({id}) => setValue(id)}
    value={options?.find(option => option.id === value)}
  />
};

AmountSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number,
};

export default AmountSelect;